var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { createContext } from 'react';
export var FormContext = createContext(undefined);
// TODO 用 ystore 那种方式传递 form 节点，这样就能有类型提示了
export var FormProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(FormContext.Provider, { value: props }, children);
};
